// DS: i9.7
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import IconWrap, { IconSize } from '../../IconWrap';
const DollarSign = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _object_spread({
        size: IconSize.SMALLER
    }, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.472 14v-1.243a5.754 5.754 0 01-1.804-.423c-.531-.227-.946-.548-1.244-.965-.298-.416-.439-.934-.423-1.552l.017-.032h2.308c0 .564.168.968.504 1.212.336.244.759.366 1.268.366.493 0 .87-.101 1.13-.303a.993.993 0 00.398-.827c0-.34-.127-.618-.382-.832-.249-.215-.68-.415-1.292-.6-.802-.227-1.466-.467-1.992-.719-.52-.257-.91-.557-1.17-.902-.255-.35-.382-.778-.382-1.287 0-.707.29-1.285.87-1.735.585-.455 1.37-.722 2.357-.802V2h1.292v1.375c.949.11 1.694.419 2.236.928.547.505.815 1.163.804 1.975l-.024.031H9.635c0-.496-.133-.879-.399-1.148-.265-.27-.623-.404-1.073-.404-.466 0-.815.105-1.048.316-.228.206-.342.481-.342.826 0 .328.12.595.358.801.244.202.688.402 1.333.6.797.244 1.455.496 1.975.757.526.256.916.557 1.17.902.26.345.391.766.391 1.262 0 .727-.293 1.312-.878 1.754-.58.437-1.366.696-2.357.776V14H7.472z"
    })));
};
DollarSign.displayName = 'DollarSign';
export default DollarSign;
